import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    urlCall: any;
    allDetails: boolean;


    constructor(private http: HttpClient) {
    }

    getOrgCategory() {
        return this.http.get(window['url'] + '/newyess/category?includeAllDtls=true');
    }

    locationSearch(data) {
        return this.http.post(window['url'] + '/newyess/org/search', data);
    }

    getOrgCategoryDetails() {
        return this.http.get(window['url'] + '/newyess/category');

    }

    getOrgByCategorys(id) {
        return this.http.get(window['url'] + '/newyess/org?pendingOrgs=false&&orgType=3&&franchisorId=' + localStorage.getItem('organizationId') + '&&category=' + id);
    }

    getAllItems() {
        return this.http.get(window['url'] + '/newyess/providerServices' + '?activeOnly=true');
    }

    getAllItemsByCategory(id, data) {
        return this.http.get(window['url'] + '/newyess/providerServices' + '?activeOnly=true&&itemCategory=' + id + '&&packageInd=' + data);
    }

    getTimeSlots(date, post) {
        return this.http.post(window['url'] + '/kairos-svcs/schedule/date/' + date + '/availableTimeSlots', post);
    }

    getUserDetailsById(id) {
        return this.http.get(window['url'] + '/newyess/users/' + id + '?includeAllDtls=true');
    }

    getAllCategory() {
        return this.http.get(window['url'] + '/newyess/staticdata/promotionCategory');
    }

    getPromotionById(id) {
        return this.http.get(window['url'] + '/newyess/promotions/' + id);
    }

    getAllType() {
        return this.http.get(window['url'] + '/newyess/staticdata/promotionType');
    }

    createPromotion(data) {
        return this.http.post(window['url'] + '/newyess/promotions', data);
    }

    updatePromotion(id, data) {
        return this.http.put(window['url'] + '/newyess/promotions/' + id, data);
    }

    deletePromotion(id) {
        return this.http.delete(window['url'] + '/newyess/promotions/' + id);
    }

    updateOrder(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id, data);
    }

    bookservice(post) {
        return this.http.post(window['url'] + '/newyess/orders', post);
    }

    getOrderById(id) {
        return this.http.get(window['url'] + '/newyess/orders/' + id + '?checkOut=true&&cnvcChargeApplied=true');
    }

    getOrderByIdOri(id) {
        return this.http.get(window['url'] + '/newyess/orders/' + id);
    }

    completeOrder(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/placeOrder', data);
    }

    postTrainerLocation(data) {
        return this.http.post(window['url'] + '/newyess/trainerLocation', data);
    }

    getTrainerLocation() {
        return this.http.get(window['url'] + '/newyess/trainerLocation');
    }

    getOrgByRadius(lat, lon) {
        return this.http.get(window['url'] + '/newyess/org?pendingOrgs=false&&orgType=3&&franchisorId=' + localStorage.getItem('organizationId') + '&&lat=' + lat + '&&lon=' + lon + '&&radius=5');
    }

    sendMobileOtp(id, data) {
        return this.http.post(window['url'] + '/userManagement/login/' + id + '/smsOTP', data)
    }

    validateOtp(data) {
        return this.http.post(window['url'] + '/userManagement/login/validateResetPasswordOTP', data);
    }

    validateOtpForYb(data) {
        return this.http.post(window['url'] + '/userManagement/login/validateResetPasswordOTPForYB', data);
    }

    updateOrderItem(id, id1, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/items/' + id1, data);
    }

    orderItemPost(orderId, itemId, data) {
        return this.http.post(window['url'] + '/newyess/orders/' + orderId + '/items/' + itemId, data);
    }

    placeOrder(data) {
        return this.http.post(window['url'] + '/newyess/orders', data);
    }

    searchStorePurchase(fdate, tdate) {
        return this.http.post(window['url'] + '/newyess/orders/search?fromDate=' + fdate + '&&toDate=' + tdate + '&&fetchType=2', null);
    }

    sendPdfToEmail(email, data, name) {
        const formData: FormData = new FormData();
        formData.append('file', data, name);
        return this.http.post(window['url'] + '/newyess/notifications/sendFile?emailId=' + email + '&&subject=CUSTOMER-INVOICE', formData);
    }

    getPaytmHash(post) {
        return this.http.post(window['url'] + '/newyess/paymntHashGnrtr/initiale', post);
    }

    getPaytmHashOrder(post) {
        return this.http.post(window['url'] + '/newyess/orderPaymntHashGnrtr/initiate', post);
    }

    updateUser(id, post) {
        return this.http.put(window['url'] + '/newyess/users/' + id, post);
    }

    cancelOrder(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/cancel', data);
    }

    getOrgForAdsSpace(deviceId) {
        return this.http.get(window['url'] + '/newyess/ads?adAge=true&&deviceType=' + deviceId);
    }

    getDocument(id) {
        return this.http.get(window['url'] + '/newyess/documents/' + id, { responseType: 'arraybuffer' })
    }

    postScoreAssessment(id1, id2, id3, score, data) {
        return this.http.post(window['url'] + '/newyess/assessments/' + id1 + '/user/' + id3 + '/score?qnId=' + id2 + '&score=' + score, data);
    }

    // getAssessmentsByServiceId(id) {
    //   return this.http.get(window['url'] + '/newyess/assessments?providerServiceId=' + id + '&type=1');
    // }
    getAllServices() {
        return this.http.get(window['url'] + '/newyess/providerServices?activeOnly=false');
    }

    getAssessment(id) {
        return this.http.get(window['url'] + '/newyess/assessments/' + id);
    }

    deleteAssessmentQtn(id, qtnId) {
        return this.http.delete(window['url'] + '/newyess/assessments/' + id + '/question/' + qtnId);
    }

    createAssessment(data) {
        return this.http.post(window['url'] + '/newyess/assessments', data);
    }

    editAssessment(id, data) {
        return this.http.put(window['url'] + '/newyess/assessments/' + id, data);
    }

    getAssessmentsOrg(id) {
        return this.http.get(window['url'] + '/newyess/assessments?activeOnly=false&&orgId=' + id + '&&type=1');
    }

    getAssessmentsByServiceId(id) {
        return this.http.get(window['url'] + '/newyess/assessments?providerServiceId=' + id + '&type=1');
    }

    getfeedbackOrg(id) {
        return this.http.get(window['url'] + '/newyess/assessments?activeOnly=false&&orgId=' + id + '&&type=2');
    }

    register(data) {
        return this.http.post(window['url'] + '/userManagement/users/signUp', data);
    }

    getUsersByOrg(data, data1, pgeNbr) {
        if (data == "CUST") {
            this.allDetails = true;
        } else {
            this.allDetails = false;
        }
        this.urlCall = '/newyess/roles/users?roleCd=' + data + '&&orgId=' + data1 + '&&includeAllDtls=' + this.allDetails;

        if (pgeNbr != null) {
            this.urlCall = this.urlCall + "&&pageNbr=" + pgeNbr + "&&pageSize=50"
        }

        return this.http.get(window['url'] + this.urlCall);
    }

    getUsersByOrgAllDetails(data, data1) {
        return this.http.get(window['url'] + '/newyess/roles/users?roleCd=' + data + '&&orgId=' + data1 + '&&includeAllDtls=true');
    }

    getUsersByOrgAndCate(data, data1, data2) {
        return this.http.get(window['url'] + '/newyess/roles/users?roleCd=' + data + '&&orgId=' + data1 + '&&includeAllDtls=true&&categoryId=' + data2);
    }

    getUsersByOrgByCat(data, data1, id) {
        return this.http.get(window['url'] + '/newyess/roles/users?roleCd=' + data + '&&orgId=' + data1 + '&&includeAllDtls=false&&categoryId=' + id);
    }

    getUsers(data) {
        return this.http.get(window['url'] + '/newyess/roles/users?roleCd=' + data + '&&includeAllDtls=true');
    }

    searchCustomers(da, data, orgId) {
        return this.http.get(window['url'] + '/newyess/roles/users?roleCd=' + da + '&&firstName=' + data + '&&orgId=' + orgId + '&&includeAllDtls=true');
    }

    searchCustNumber(id, fDate, tDate, cName) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker?categoryId=' + id + '&&fromDate=' + fDate + '&&toDate=' + tDate + '&&custName=' + cName);
    }

    getUserById(id) {
        return this.http.get(window['url'] + '/newyess/users/' + id + '?includeAllDtls=true');
    }

    postProfileDetails(id, data) {
        return this.http.put(window['url'] + '/newyess/users/' + id, data)
    }

    getAppointReq2(data) {
        return this.http.post(window['url'] + '/newyess/requests/search', data);
    }

    getOrders(data) {
        return this.http.post(window['url'] + '/newyess/orders/search', data);
    }

    getRequestById(id) {
        return this.http.get(window['url'] + '/newyess/requests/' + id);
    }

    getPackageById(id) {
        return this.http.get(window['url'] + '/newyess/packRequests?requestorId=' + id);
    }


    // getUserProfile() {
    getOrg() {
        return this.http.get(window['url'] + '/newyess/org?franchisorId=' + localStorage.getItem('organizationId'));
    }

    getCategoriesByOrg(id) {
        return this.http.get(window['url'] + '/newyess/org/' + id + '/categories');
    }

    //   return this.http.get(window['url'] + '/userManagement/users/' + localStorage.getItem('currentUserId') + '/basicDetails');
    // }
    // getUserProfile1(id) {
    //   return this.http.get(window['url'] + '/userManagement/users/' + id + '/basicDetails');
    // }
    getAddressById(id) {
        return this.http.get(window['url'] + '/newyess/users/' + id + '?includeAllDtls=true');
    }

    updateUser1(id, post) {
        return this.http.put(window['url'] + '/newyess/users/' + id, post);
    }

    getOrgbyfranchasee() {
        return this.http.get(window['url'] + '/newyess/org/?orgType=2');
    }

    orgRegister(data) {
        return this.http.post(window['url'] + '/newyess/org', data);
    }

    createCategory(data) {
        return this.http.post(window['url'] + '/newyess/category', data);
    }

    updateCategory(id, data) {
        return this.http.put(window['url'] + '/newyess/category/' + id, data);
    }

    deleteCategory(id) {
        return this.http.delete(window['url'] + '/newyess/category/' + id);
    }

    getCategory() {
        return this.http.get(window['url'] + '/newyess/category');
    }

    getCategoryById(id) {
        return this.http.get(window['url'] + '/newyess/category/' + id);
    }

    createItem(data) {
        return this.http.post(window['url'] + '/newyess/providerServices', data);
    }

    getPromotions() {
        return this.http.get(window['url'] + '/newyess/staticdata/itemPromotions');
    }

    getAllPromotion() {
        return this.http.get(window['url'] + '/newyess/promotions');
    }

    updateItem(id, data) {
        return this.http.put(window['url'] + '/newyess/providerServices/' + id, data);
    }

    registerAdmin(data) {
        return this.http.post(window['url'] + '/userManagement/users/signUp', data);
    }

    getItemById(id) {
        return this.http.get(window['url'] + '/newyess/providerServices/' + id);
    }

    getServiceCoupon(id) {
        return this.http.get(window['url'] + '/newyess/ads/orgCoupons?orgId=' + id);
    }

    custItem(post) {
        return this.http.post(window['url'] + '/newyess/custItems', post);
    }

    allcustItem() {
        return this.http.get(window['url'] + '/newyess/custItems');
    }

    custItemById(id) {
        return this.http.get(window['url'] + '/newyess/custItems/' + id);
    }

    updatecustItem(id, data) {
        return this.http.put(window['url'] + '/newyess/custItems/' + id, data);
    }

    createSubscriptions(data) {
        return this.http.post(window['url'] + '/newyess/providerServices', data);
    }

    getAllSubscriptions() {
        return this.http.get(window['url'] + '/newyess/providerServices' + '?activeOnly=true');
    }

    getSubscriptionById(id) {
        return this.http.get(window['url'] + '/newyess/providerServices/' + id + '?allDetails=true');
    }

    updateSubscription(id, data) {
        return this.http.put(window['url'] + '/newyess/providerServices/' + id, data);
    }

    getEqType() {
        return this.http.get(window['url'] + '/newyess/eqTypes');
    }

    getTimePref() {
        return this.http.get(window['url'] + '/newyess/staticdata/timePreference');
    }

    getReasons() {
        return this.http.get(window['url'] + '/newyess/staticdata/reasons');
    }

    deleteSubscription(id) {
        return this.http.delete(window['url'] + '/newyess/subscriptions/' + id);
    }

    notInPlace(id, id1, file) {
        const formData = new FormData();
        formData.append('file', file, id)
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/date/notInPlace?status=' + id1 + '&&displayName=' + id, formData);
    }

    // notInPlace(data,id){
    //   return this.http.put(window['url']  + '/newyess/requests/' + id +'/date/notInPlace', data);
    //  }
    missed(data, id) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/date/missed', data);
    }

    getMissedData() {
        return this.http.get(window['url'] + '/newyess/staticdata/reasonsForMissed');
    }

    completed(data, id) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/date/completed', data);
    }

    updateReasons(data, id) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/reason', data);
    }

    getDailyStatus() {
        return this.http.get(window['url'] + '/newyess/staticdata/trackingStatus');
    }

    vendorApproval(id, id1) {
        return this.http.put(window['url'] + '/newyess/users/' + id + '/role/' + id1 + '/approve', null);
    }

    vendorReject(id, id1) {
        return this.http.put(window['url'] + '/newyess/users/' + id + '/role/' + id1 + '/reject', null);
    }

    deleteService(id) {
        return this.http.delete(window['url'] + '/newyess/items/' + id);
    }

    sendForgetOtp(data) {
        return this.http.post(window['url'] + '/userManagement/login/forgotPassword', data);
    }

    resetpass(data) {
        return this.http.put(window['url'] + '/userManagement/login/newPassword?reset=true', data);
    }

    getIdProof() {
        return this.http.get(window['url'] + '/newyess/staticdata/idProof');
    }

    getAddressProof() {
        return this.http.get(window['url'] + '/newyess/staticdata/addressProof');
    }

    allcustItemSubscription() {
        return this.http.get(window['url'] + '/newyess/custItems');
    }

    getItemCategory() {
        return this.http.get(window['url'] + '/newyess/staticdata/itemCategory');
    }

    getItemType() {
        return this.http.get(window['url'] + '/newyess/staticdata/types');
    }

    getBillingPeriod() {
        return this.http.get(window['url'] + '/newyess/staticdata/billingPeriod');
    }

    getApplicableDays() {
        return this.http.get(window['url'] + '/newyess/staticdata/applicableDays');
    }

    getRecurrence() {
        return this.http.get(window['url'] + '/newyess/staticdata/recurrence');
    }

    getCost(data) {
        return this.http.post(window['url'] + '/newyess/providerServices/search ', data);
    }

    getPayTotal(data) {
        return this.http.post(window['url'] + '/newyess/subscriptions/discountApply ', data);
    }

    getOrgById(id) {
        return this.http.get(window['url'] + '/newyess/org/' + id + '?includeAllDtls=true');
    }

    getCapability(id) {
        return this.http.get(window['url'] + '/newyess/users/' + id + '/capabilities');
    }

    updateOrg(id, post) {
        return this.http.put(window['url'] + '/newyess/org/' + id, post);
    }

    custItemSubscription(data) {
        return this.http.post(window['url'] + '/newyess/subscriptions', data);
    }

    getAllCustItemSubs() {
        return this.http.get(window['url'] + '/newyess/subscriptions');
    }

    getCustItemSubsCate(id, id1) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?categoryId=' + id + '&&pageNbr=' + id1 + '&&pageSize=50');
    }

    searchCustItemSubsCate(cName) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?custName=' + cName);
    }

    getCustItemSubsCateMatTable(id) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?categoryId=' + id);
    }

    getConCustItemSubs(id, id1) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?serviceContractorId=' + id + '&&status=' + id1);
    }

    getVenCustItemSubsCate(id, id1, id2) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?vendorId=' + id + '&&categoryId=' + id1 + '&&pageNbr=' + id2 + '&&pageSize=50');
    }

    searchVenCustItemSubsCate(id, cName) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?vendorId=' + id + '&&custName=' + cName);
    }

    getVenCustItemSubsCateMatTable(id, id1) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?vendorId=' + id + '&&categoryId=' + id1);
    }

    getCustSubs(id) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?requestorId=' + id);
    }

    getSubsMonthlyStatus(id, id1) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?status=' + id + '&&categoryId=' + id1);
    }

    getCustomerItemSubs(id) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?requestorId=' + id);
    }

    getCustomerItemSubsCate(id, id1) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?requestorId=' + id + '&&categoryId=' + id1);
    }

    getVenCustItemSubs(id, id1) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?vendorId=' + id + '&&status=' + id1);
    }

    getCustItemSubsById(id) {
        return this.http.get(window['url'] + '/newyess/subscriptions/' + id);
    }

    updateCustItemSubs(id, data) {
        return this.http.put(window['url'] + '/newyess/subscriptions/' + id, data);
    }

    deleteCustItem(id) {
        return this.http.delete(window['url'] + '/newyess/custItems/' + id);
    }

    deleteCustItemSubs(id) {
        return this.http.delete(window['url'] + '/newyess/custItemSubscriptions/' + id);
    }

    confirmReq(id, data) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/assign', data);
    }

    confirmEmpReq(id, data) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/confirm', data);
    }

    confirmEmpOrder(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/confirm', data);
    }

    confirmPackReq(id, data) {
        return this.http.put(window['url'] + '/newyess/subscriptions/' + id + '/assign', data);
    }

    confirmPackageReq(id, data) {
        return this.http.put(window['url'] + '/newyess/requests/package/' + id + '/confirm', data);
    }

    changeAllocReq(id, data) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/changeContractor', data);
    }

    cancelReq(id, data) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/cancel', data);
    }

    cancelReqCust(id) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/cancel', null);
    }

    cancelPackageReq(id, data) {
        return this.http.put(window['url'] + '/newyess/subscriptions/' + id + '/cancel', data);
    }

    deletePackageReq(id) {
        return this.http.delete(window['url'] + '/newyess/subscriptions/' + id);
    }

    createSingleReq(data) {
        return this.http.post(window['url'] + '/newyess/requests', data);
    }

    getAllRequest() {
        return this.http.get(window['url'] + '/newyess/requests');
    }

    getVenAllRequest(id, id1) {
        return this.http.get(window['url'] + '/newyess/requests' + '?vendorId=' + id + '&&status=' + id1);
    }

    getVenAllConRequest(id, id1) {
        return this.http.get(window['url'] + '/newyess/requests' + '?serviceContractorId=' + id + '&&status=' + id1);
    }

    getAllRequestCategory(date, id1) {
        return this.http.get(window['url'] + '/newyess/requests' + '?subscriptionInd=false&&apptDate=' + date + '&&pageNbr=' + id1 + '&&pageSize=50');
    }

    getAllRequestMatTable(date) {
        return this.http.get(window['url'] + '/newyess/requests' + '?subscriptionInd=false&&apptDate=' + date);
    }

    getAllRequestStatus(id, id1, date) {
        return this.http.get(window['url'] + '/newyess/requests' + '?vendorId=' + id + '&&categoryId=' + id1 + '&&subscriptionInd=false&&apptDate=' + date);
    }

    getAllSinRequestStatus(id, date, id1) {
        return this.http.get(window['url'] + '/newyess/requests' + '?vendorId=' + id + '&&subscriptionInd=false&&apptDate=' + date + '&&pageNbr=' + id1 + '&&pageSize=50');
    }

    getAllSinRequestStatusMatTable(id, date) {
        return this.http.get(window['url'] + '/newyess/requests' + '?vendorId=' + id + '&&subscriptionInd=false&&apptDate=' + date);
    }

    getCustRequestStatus(id, id1, date) {
        return this.http.get(window['url'] + '/newyess/requests' + '?requestorId=' + id + '&&categoryId=' + id1 + '&&subscriptionInd=false&&apptDate=' + date);
    }

    getCustRequest(id) {
        return this.http.get(window['url'] + '/newyess/requests' + '?requestorId=' + id + '&&subscriptionInd=false');
    }

    getAllOrder(id, nbr) {
        return this.http.get(window['url'] + '/newyess/orders' + '?orderType=1&&customerId=' + id + '&&pageNbr=' + nbr + '&&pageSize=50');
    }

    getAllOrderByCustomerId(id, id1) {
        return this.http.get(window['url'] + '/newyess/orders' + '?customerId=' + id + '&&pageNbr=' + id1 + '&&pageSize=50');
    }

    getAllOrderByDate(date, nbr) {
        return this.http.get(window['url'] + '/newyess/orders' + '?orderType=1&&apptDate=' + date + '&&pageNbr=' + nbr + '&&pageSize=50');
    }

    getAllOrderByType(date, nbr) {
        return this.http.get(window['url'] + '/newyess/orders' + '?orderType=2&&orderDate=' + date + '&&pageNbr=' + nbr + '&&pageSize=50');
    }

    dispatchOrder(id) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/dispatch', null);
    }

    getAllOrderByDateAndType(date, nbr) {
        return this.http.get(window['url'] + '/newyess/orders' + '?orderType=2&&expectedDeliveryDate=' + date + '&&pageNbr=' + nbr + '&&pageSize=50');
    }

    getAllOrdersByStatus(id, id1) {
        return this.http.get(window['url'] + '/newyess/orders' + '?orderType=1&&vendorId=' + id + '&&status=' + id1);
    }

    getConOrdersByStatus(id, id1) {
        return this.http.get(window['url'] + '/newyess/orders' + '?orderType=1&&serviceContractorId=' + id + '&&status=' + id1);
    }

    getConOrdersByDate(id, id1, fdate, tdate) {
        return this.http.get(window['url'] + '/newyess/orders' + '?orderType=1&&serviceContractorId=' + id + '&&status=' + id1 + '&&fromDate=' + fdate + '&&toDate=' + tdate);
    }

    getAllRoles() {
        return this.http.get(window['url'] + '/newyess/roles');
    }

    editRole(id, data) {
        return this.http.put(window['url'] + '/newyess/roles/' + id, data);
    }

    postcapabilitiesById(id, data) {
        return this.http.post(window['url'] + '/newyess/roles/' + id + '/capabilities', data);
    }

    roleCreate(data) {
        return this.http.post(window['url'] + '/newyess/roles', data);
    }

    getAllCapabilities() {
        return this.http.get(window['url'] + '/newyess/capabilities');
    }

    getAllRolesById(id) {
        return this.http.get(window['url'] + '/newyess/roles/' + id);
    }

    getcapabilitiesById(id) {
        return this.http.get(window['url'] + '/newyess/roles/' + id + '/capabilities');
    }

    postAssociateRoles(id, data) {
        return this.http.post(window['url'] + '/newyess/users/' + id + '/roles', data);
    }

    getAssociateRoles() {
        return this.http.get(window['url'] + '/newyess/roles');
    }

    getConfig() {
        return this.http.get(window['url'] + '/newyess/appConfigs');
    }

    postConfig(data) {
        return this.http.post(window['url'] + '/newyess/appConfigs', data);
    }

    orgApproval(id) {
        return this.http.put(window['url'] + '/newyess/org/' + id + '/approve', null);
    }

    orgReject(id) {
        return this.http.put(window['url'] + '/newyess/org/' + id + '/reject', null);
    }

    getPendingOrgs() {
        return this.http.get(window['url'] + '/newyess/org?pendingOrgs=true&&franchisorId=' + localStorage.getItem('organizationId'));
    }

    getAwardDocs() {
        var id = localStorage.getItem('currentUserId')
        return this.http.get(window['url'] + '/newyess/documents?docStore=USERDOCS' + '&&userId=' + id);
    }

    uploadDoc(files, name, desc, id, uId) {
        const formData: FormData = new FormData();
        formData.append('file', files, files.name);
        return this.http.post(window['url'] + '/newyess/documents?docStore=USERDOCS&&displayName=' + name + '&&description=' + desc + '&&orgId=' + id + '&&docOwner=' + uId, formData);
    }

    registerInapp(data) {
        return this.http.post(window['url'] + '/userManagement/users/signUp', data);
    }

    postAd(data) {
        return this.http.post(window['url'] + '/newyess/ads', data);
    }

    postAdimage1(id, deviceId, data) {
        const formData: FormData = new FormData();
        formData.append('file', data, data.name);
        return this.http.post(window['url'] + '/newyess/ads/' + id + '/refDoc?deviceType=' + deviceId, formData);
    }

    generateInvoiceByDate(fdate, tdate) {
        return this.http.get(window['url'] + '/newyess/invoices/settlementInvoice?fromDate=' + fdate + '&&toDate=' + tdate
            + '&&orgId=' + sessionStorage.getItem('orgId'));
    }

    getInvoiceByDate(id, fdate, tdate, type) {
        return this.http.get(window['url'] + '/newyess/invoices?orgId=' + id + '&&fromDate=' + fdate + '&&toDate=' + tdate + '&&type=' + type);
    }

    getInvoiceById(id) {
        return this.http.get(window['url'] + '/newyess/invoices/' + id);
    }

    applyDiscount(id, id1, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/applyDiscount?discountPct=' + id1, data);
    }

    getPaymentInvoices(id) {
        return this.http.get(window['url'] + '/newyess/invoices/' + id + '/paymentAccounts')
    }

    postPaymentForPurchaseAdd(id, data) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/recordPayment/', data);
    }

    getPackageByInvoice(id) {
        return this.http.get(window['url'] + '/newyess/packRequests?packageId=' + id);
    }

    getAdById(id) {
        return this.http.get(window['url'] + '/newyess/ads/' + id);
    }

    getImage(id) {
        return this.http.get(window['url'] + '/newyess/documents/' + id, { responseType: 'arraybuffer' });
    }

    editAd(id, data) {
        return this.http.put(window['url'] + '/newyess/ads/' + id, data);
    }

    publishAd(id) {
        return this.http.put(window['url'] + '/newyess/ads/' + id + '/publish', null)
    }

    approveAd(id) {
        return this.http.put(window['url'] + '/newyess/ads/' + id + '/approve', null)
    }

    getOrgAds(id) {
        return this.http.get(window['url'] + '/newyess/ads?orgId=' + id);
    }

    getAllAds() {
        return this.http.get(window['url'] + '/newyess/ads');
    }

    getRewardAds() {
        return this.http.get(window['url'] + '/newyess/ads?status=3&&adType=1');
    }

    getRewardAdsOrgBased(id) {
        return this.http.get(window['url'] + '/newyess/ads?status=3&&adType=1&&orgId=' + id);
    }

    getOrgAddressById(id) {
        return this.http.get(window['url'] + '/newyess/org/' + id + '?includeAllDtls=true');
    }

    postReferrals(data) {
        return this.http.post(window['url'] + '/newyess/referrals', data);
    }
    shareReferrals(data) {
        return this.http.post(window['url'] + '/newyess/referrals/sharingAppReferralLink', data);
    }

    getOrgByCode(data) {
        return this.http.get(window['url'] + '/newyess/org/organizations/' + data);
    }

    getReferralList(data) {
        return this.http.get(window['url'] + '/newyess/referrals?serviceProviderId=' + data);
    }

    getPaymentDetails(id) {
        return this.http.get(window['url'] + '/newyess/requests/' + id + '/paymentAccounts')
    }

    postPaymentDetails(id, data) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/recordPayment', data);
    }

    postSubsPaymentDetails(id, data) {
        return this.http.put(window['url'] + '/newyess/subscriptions/' + id + '/recordPayment/month', data);
    }

    postOrderPaymentDetails(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/recordPay', data);
    }

    postPaymentForInvoice(id, data) {
        return this.http.put(window['url'] + '/newyess/invoices/' + id + '/recordPayment', data);
    }

    sendNotification(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/paymentRemainder', data);
    }

    sendOrderNotification(id, data) {
        return this.http.put(window['url'] + '/newyess/subscriptions/' + id + '/paymentReminder', data);
    }

    sendReqNotification(id, data) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/paymentReminder', data);
    }

    customerSearch(data) {
        return this.http.post(window['url'] + '/newyess/users/search?preview=true', data);
    }

    summarySubs() {
        return this.http.get(window['url'] + '/newyess/subscriptions/summary?onlyPendingActions=true&&vendorId=' + localStorage.getItem('organizationId') + '&&status=9')
    }

    summaryReq() {
        return this.http.get(window['url'] + '/newyess/requests/summary?onlyPendingActions=true&&serviceContractorId=' + localStorage.getItem('currentUserId') + '&&status=6')
    }

    summaryReq1() {
        return this.http.get(window['url'] + '/newyess/requests/summary?onlyPendingActions=true&&vendorId=' + localStorage.getItem('organizationId') + '&&status=9&&status=6')
    }

    getDocumentImg(id) {
        return this.http.get(window['url'] + '/newyess/documents/' + id, { responseType: 'blob' })
    }

    getPaymentActivity(id) {
        return this.http.get(window['url'] + '/newyess/subscriptions/' + id + '/paymentActivity')
    }

    monthlyTracker(id, fdate, tdate) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker?categoryId=' + id + '&&fromDate=' + fdate + '&&toDate=' + tdate)
    }

    monthlyTrackerOtherOrg(id, id1, fdate, tdate) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker?categoryId=' + id + '&&vendorId=' + id1 + '&&fromDate=' + fdate + '&&toDate=' + tdate)
    }

    monthlyTrackerCon(id, id1, fdate, tdate) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker?categoryId=' + id + '&&serviceContractorId=' + id1 + '&&fromDate=' + fdate + '&&toDate=' + tdate)
    }

    getGroupSubs(data) {
        return this.http.post(window['url'] + '/newyess/subscriptions/search', data);
    }

    getPaymentRemainderMsg() {
        return this.http.get(window['url'] + '/newyess/requests/paymentReminderCheck')
    }

    getPaymentRemainderMsgSubs() {
        return this.http.get(window['url'] + '/newyess/subscriptions/paymentReminderCheck')
    }

    getInvoiceByDateBypage(id, fdate, tdate, type, id1) {
        return this.http.get(window['url'] + '/newyess/invoices?orgId=' + id + '&&fromDate=' + fdate + '&&toDate=' + tdate + '&&type=' + type + '&&pageNbr=' + id1 + '&&pageSize=50');
    }

    customerMonthlyTracker(id, fdate, tdate) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker?subscriptionId=' + id + '&&fromDate=' + fdate + '&&toDate=' + tdate);
    }

    monthlyTrackerByPage(id, fdate, tdate, id3) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker?categoryId=' + id + '&&fromDate=' + fdate + '&&toDate=' + tdate + '&&pageNbr=' + id3 + '&&pageSize=50')
    }

    monthlyTrackerOtherOrgBypage(id, id1, fdate, tdate, id3) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker?categoryId=' + id + '&&vendorId=' + id1 + '&&fromDate=' + fdate + '&&toDate=' + tdate + '&&pageNbr=' + id3 + '&&pageSize=50')
    }

    monthlyTrackerOtherOrgBypageSearch(id, id1, fdate, tdate, cName) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker?categoryId=' + id + '&&vendorId=' + id1 + '&&fromDate=' + fdate + '&&toDate=' + tdate + '&&custName=' + cName)
    }

    monthlyTrackerConBypage(id, id1, fdate, tdate, id3) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker?categoryId=' + id + '&&serviceContractorId=' + id1 + '&&fromDate=' + fdate + '&&toDate=' + tdate + '&&pageNbr=' + id3 + '&&pageSize=50')
    }

    monthlyTrackerConBypageSearch(id, id1, fdate, tdate, cName) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker?categoryId=' + id + '&&serviceContractorId=' + id1 + '&&fromDate=' + fdate + '&&toDate=' + tdate + '&&custName=' + cName)
    }

    getCustomerItemSubsCate1(data, id1) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?' + data + "=" + id1);
    }

    getCustomerItemSubsCate2(data, data1, id1, id2) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2);
    }

    getCustomerItemSubsCate3(data, data1, data2, id1, id2, id3) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3);
    }

    getCustomerItemSubsCate4(data, data1, data2, data3, id1, id2, id3, id4) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&' + data3 + '=' + id4);
    }

    getCustomerItemSubsCate5(data, data1, data2, data3, data4, id1, id2, id3, id4, id5) {
        return this.http.get(window['url'] + '/newyess/subscriptions' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&' + data3 + '=' + id4 + '&&' + data4 + '=' + id5);
    }

    getCustomerItemReqCate1(data, id1, date) {
        return this.http.get(window['url'] + '/newyess/requests' + '?' + data + "=" + id1 + '&&apptDate=' + date + '&&subscriptionInd=false');
    }

    getCustomerItemReqCate2(data, data1, id1, id2, date) {
        return this.http.get(window['url'] + '/newyess/requests' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&apptDate=' + date + '&&subscriptionInd=false');
    }

    getCustomerItemReqCate3(data, data1, data2, id1, id2, id3, date) {
        return this.http.get(window['url'] + '/newyess/requests' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&apptDate=' + date + '&&subscriptionInd=false');
    }

    getCustomerItemReqCate4(data, data1, data2, data3, id1, id2, id3, id4, date) {
        return this.http.get(window['url'] + '/newyess/requests' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&' + data3 + '=' + id4 + '&&apptDate=' + date + '&&subscriptionInd=false');
    }

    getCustomerItemReqCate5(data, data1, data2, data3, data4, id1, id2, id3, id4, id5, date) {
        return this.http.get(window['url'] + '/newyess/requests' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&' + data3 + '=' + id4 + '&&' + data4 + '=' + id5 + '&&apptDate=' + date + '&&subscriptionInd=false');
    }

    searchInvoiceByName(id, cName, date1, date2) {
        return this.http.get(window['url'] + '/newyess/invoices?payerName=' + cName + '&&orgId=' + id + '&&fromDate=' + date1 + '&&toDate=' + date2);
    }

    searchInvoiceById(id, id1, date1, date2) {
        return this.http.get(window['url'] + '/newyess/invoices?invoiceNbr=' + id1 + '&&orgId=' + id + '&&fromDate=' + date1 + '&&toDate=' + date2);
    }

    getCalendar(date, data) {
        return this.http.post(window['url'] + '/kairos-svcs/schedule/date/' + date + '/getTimeSlots', data);
    }

    getBlocks(date) {
        return this.http.get(window['url'] + '/kairos-svcs/appointments?typeId=2&targetSource=' + localStorage.getItem('currentUserId') + '&date=' + date);
    }

    postAppointments(post) {
        return this.http.post(window['url'] + '/kairos-svcs/appointments', post);
    }

    unBlockSlot(id) {
        return this.http.put(window['url'] + '/kairos-svcs/appointments/' + id + '/unblockAppt', null);
    }

    manageCalGet(data) {
        return this.http.post(window['url'] + '/kairos-svcs/schdlConfigs/capacityDef/search', data);
    }

    manageCalPost(data) {
        return this.http.post(window['url'] + '/kairos-svcs/schdlConfigs/capacityDef', data);
    }

    deleteSlots(id) {
        return this.http.delete(window['url'] + '/kairos-svcs/schdlConfigs/capacityDef/' + id);
    }

    getSubItemType() {
        return this.http.get(window['url'] + '/newyess/staticdata/subItemType');
    }

    getcancellationReason() {
        return this.http.get(window['url'] + '/newyess/staticdata/cancellationReason');
    }

    getorderCancelReason() {
        return this.http.get(window['url'] + '/newyess/staticdata/orderCancelReason');
    }

    getSubscriptionCount(id) {
        return this.http.get(window['url'] + '/newyess/subscriptions/summary?categoryId=' + id);
    }

    getPendingBalanceRecord(id) {
        return this.http.get(window['url'] + '/newyess/users/' + id + '/pendingBalance');
    }

    getPendingBalanceOrder(id) {
        return this.http.get(window['url'] + '/newyess/users/' + id + '/orderPendingBalance');
    }

    getServiceTrackerCount(id, fDate, tDate) {
        return this.http.get(window['url'] + '/newyess/subscriptions/summary?categoryId=' + id + '&&fromDate' + fDate + '&&toDate' + tDate);
    }

    getServiceTrackerCountByOrg(id, id1, fDate, tDate) {
        return this.http.get(window['url'] + '/newyess/subscriptions/summary?categoryId=' + id + '&&vendorId=' + id1 + '&&fromDate' + fDate + '&&toDate' + tDate);
    }

    getServiceTrackerCountByCon(id, id1, fDate, tDate) {
        return this.http.get(window['url'] + '/newyess/subscriptions/summary?categoryId=' + id + '&&serviceContractorId=' + id1 + '&&fromDate' + fDate + '&&toDate' + tDate);
    }

    getAllbrand() {
        return this.http.get(window['url'] + '/newyess/brands');
    }

    getAllcolor() {
        return this.http.get(window['url'] + '/newyess/color');
    }

    getcolorById(id) {
        return this.http.get(window['url'] + '/newyess/color/' + id);
    }

    createcolor(data) {
        return this.http.post(window['url'] + '/newyess/color', data);
    }

    updatecolor(id, data) {
        return this.http.put(window['url'] + '/newyess/color/' + id, data);
    }

    deletecolor(id) {
        return this.http.delete(window['url'] + '/newyess/color/' + id);
    }

    getsizeById(id) {
        return this.http.get(window['url'] + '/newyess/size/' + id);
    }

    createsize(data) {
        return this.http.post(window['url'] + '/newyess/size', data);
    }

    updatesize(id, data) {
        return this.http.put(window['url'] + '/newyess/size/' + id, data);
    }

    getAllsize() {
        return this.http.get(window['url'] + '/newyess/size');
    }

    deletesize(id) {
        return this.http.delete(window['url'] + '/newyess/size/' + id);
    }

    createBrand(data) {
        return this.http.post(window['url'] + '/newyess/brands', data);
    }

    updateBrand(id, data) {
        return this.http.put(window['url'] + '/newyess/brands/' + id, data);
    }

    deleteBrand(id) {
        return this.http.delete(window['url'] + '/newyess/brands/' + id);
    }

    getBrandById(id) {
        return this.http.get(window['url'] + '/newyess/brands/' + id);
    }

    getAllProduct() {
        return this.http.get(window['url'] + '/newyess/product');
    }

    getProductById(id) {
        return this.http.get(window['url'] + '/newyess/product/' + id);
    }

    deleteProductById(id) {
        return this.http.delete(window['url'] + '/newyess/product/' + id);
    }

    createProduct(data) {
        return this.http.post(window['url'] + '/newyess/product', data);
    }

    updateProduct(id, data) {
        return this.http.put(window['url'] + '/newyess/product/' + id, data);
    }

    uploadDocIcon(id, files, id1) {
        const formData: FormData = new FormData();
        formData.append('file', files, files.name);
        return this.http.post(window['url'] + '/newyess/documents/' + id + '/icon' + '?providerServiceId=' + id1, formData)
    }

    uploadVideoFile(files, name) {
        const docstore = 'TRAINERDOCS';
        const formData: FormData = new FormData();
        formData.append('file', files, files.name);
        const orgId = localStorage.getItem('organizationId');
        const userId = localStorage.getItem('currentUserId');
        return this.http.post(window['url'] + '/newyess/documents?docStore=' + docstore + '&&orgId=' + orgId + '&&userId=' + userId + '&&displayName=' + name + '&&description=' + name + '&&type=7', formData);
    }

    uploadImageFile(files, name, id) {
        const docstore = 'TRAINERDOCS';
        const formData: FormData = new FormData();
        formData.append('file', files, files.name);
        const orgId = localStorage.getItem('organizationId');
        const userId = localStorage.getItem('currentUserId');
        return this.http.post(window['url'] + '/newyess/documents?docStore=' + docstore + '&&orgId=' + orgId + '&&userId=' + userId + '&&displayName=' + name + '&&description=' + name + '&&type=7' + '&&providerServiceId=' + id, formData);
    }

    getAdImage(id) {
        return this.http.get(window['url'] + '/newyess/documents/' + id, { responseType: 'blob' })
    }

    monthlyTrackerByPageFilter1(data, data1, data2, id1, id2, id3) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3);
    }

    monthlyTrackerByPageFilter2(data, data1, data2, data3, id1, id2, id3, id4) {
        return this.http.get(window['url'] + '/newyess/subscriptions/serviceTracker' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&' + data3 + '=' + id4);
    }

    getMake(id) {
        return this.http.get(window['url'] + '/newyess/items/make?itemCategory=' + id);
    }

    getModel(id, id1) {
        return this.http.get(window['url'] + '/newyess/items/model?itemCategory=' + id + '&&make=' + id1);
    }

    getCustItemType(id, id1, id2) {
        return this.http.get(window['url'] + '/newyess/items?itemCategory=' + id + '&&make=' + id1 + '&&model=' + id2);
    }

    createItemProduct(data) {
        return this.http.post(window['url'] + '/newyess/items', data);
    }

    getItemPromotions() {
        return this.http.get(window['url'] + '/newyess/promotions');
    }

    getItemProduct() {
        return this.http.get(window['url'] + '/newyess/items');
    }

    getItemProductByCateId(id) {
        return this.http.get(window['url'] + '/newyess/items?purchaseCategory=' + id);
    }

    getItemProductById(id) {
        return this.http.get(window['url'] + '/newyess/items/' + id);
    }

    updateItemProduct(id, data) {
        return this.http.put(window['url'] + '/newyess/items/' + id, data);
    }

    getOrderCate1(data, id1, date) {
        return this.http.get(window['url'] + '/newyess/orders' + '?' + data + "=" + id1 + '&&apptDate=' + date + 'orderType=1');
    }

    getOrderCate2(data, data1, id1, id2, date) {
        return this.http.get(window['url'] + '/newyess/orders' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&apptDate=' + date + 'orderType=1');
    }

    getOrderCate3(data, data1, data2, id1, id2, id3, date) {
        return this.http.get(window['url'] + '/newyess/orders' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&apptDate=' + date + 'orderType=1');
    }

    getOrderCate4(data, data1, data2, data3, id1, id2, id3, id4, date) {
        return this.http.get(window['url'] + '/newyess/orders' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&' + data3 + '=' + id4 + '&&apptDate=' + date + 'orderType=1');
    }

    getOrderCate5(data, data1, data2, data3, data4, id1, id2, id3, id4, id5, date) {
        return this.http.get(window['url'] + '/newyess/orders' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&' + data3 + '=' + id4 + '&&' + data4 + '=' + id5 + '&&apptDate=' + date + 'orderType=1');
    }

    getOrderType1(data, id1, date) {
        return this.http.get(window['url'] + '/newyess/orders' + '?' + data + "=" + id1 + '&&orderType=2&&orderDate=' + date);
    }

    getOrderType2(data, data1, id1, id2, date) {
        return this.http.get(window['url'] + '/newyess/orders' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&orderType=2&&orderDate=' + date);
    }

    getOrderType3(data, data1, data2, id1, id2, id3, date) {
        return this.http.get(window['url'] + '/newyess/orders' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&orderType=2&&orderDate=' + date);
    }

    getOrderType4(data, data1, data2, data3, id1, id2, id3, id4, date) {
        return this.http.get(window['url'] + '/newyess/orders' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&' + data3 + '=' + id4 + '&&orderType=2&&orderDate=' + date);
    }

    getOrderType5(data, data1, data2, data3, data4, id1, id2, id3, id4, id5, date) {
        return this.http.get(window['url'] + '/newyess/orders' + '?' + data + '=' + id1 + '&&' + data1 + '=' + id2 + '&&' + data2 + '=' + id3 + '&&' + data3 + '=' + id4 + '&&' + data4 + '=' + id5 + '&&orderType=2&&orderDate=' + date);
    }

    rescheduleOrder(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/reschedule', data);
    }

    assignOrder(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/assign', data);
    }

    changeOrderAssign(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/reAssign', data);
    }

    fixedOrder(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/fixed', data);
    }

    notFixed(id, data) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/notFixed', data);
    }

    reasonsForNotFixed() {
        return this.http.get(window['url'] + '/newyess/staticdata/reasonsForNotFixed');
    }

    getAllPurchaseCategory() {
        return this.http.get(window['url'] + '/newyess/purchaseCategory');
    }

    getAllDetailedPurchaseCategory() {
        return this.http.get(window['url'] + '/newyess/purchaseCategory?includeAllDtls=true');
    }

    getAllPurchaseCategoryById(id) {
        return this.http.get(window['url'] + '/newyess/purchaseCategory/' + id);
    }

    createPurchaseCategory(data) {
        return this.http.post(window['url'] + '/newyess/purchaseCategory', data);
    }

    updatePurchaseCategory(id, data) {
        return this.http.put(window['url'] + '/newyess/purchaseCategory/' + id, data);
    }

    deletePurchaseCategory(id) {
        return this.http.delete(window['url'] + '/newyess/purchaseCategory/' + id);
    }

    customerLogin(data) {
        return this.http.post(window['url'] + '/userManagement/login/otpSignUp', data);
    }

    vendorLogin(data) {
        return this.http.post(window['url'] + '/userManagement/login/otpSignUpForVendor', data);
    }

    reasonsForReturn() {
        return this.http.get(window['url'] + '/newyess/staticdata/reasonForReturn');
    }


    getItemTypeByCategory(id) {
        return this.http.get(window['url'] + '/newyess/staticdata/itemType?itemCategory=' + id);
    }

    deliverOrder(id) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/delivered', null);
    }

    paymentConform() {
        return this.http.get(window['url'] + '/newyess/staticdata/reasonForReturn');
    }

    confirmPayment(data) {
        return this.http.post(window['url'] + '/newyess/orders/confirmPayment', data);
    }

    subsConfirmPayment(data) {
        return this.http.post(window['url'] + '/newyess/invoices/confirmPayment', data);
    }

    getAllUnits() {
        return this.http.get(window['url'] + '/newyess/staticdata/units');
    }

    applyDiscountRequest(id, id1, val, data) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/applyDiscount?couponCode=' + id1 + '&&packageInd=' + val, data);
    }

    applyDiscountOrder(id, id1) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/applyDiscount?couponCode=' + id1, null);
    }

    getSummaryOrder() {
        return this.http.get(window['url'] + '/newyess/orders/summary?onlyPendingActions=true&&status=12');
    }

    getAllOrdersByDate(id, id1, fdate, tdate) {
        return this.http.get(window['url'] + '/newyess/orders' + '?orderType=1&&vendorId=' + id + '&&status=' + id1 + '&&fromDate=' + fdate + '&&toDate=' + tdate);
    }

    getAllOrdersOnly(id, fdate, tdate) {
        return this.http.get(window['url'] + '/newyess/orders' + '?orderType=1&&status=' + id + '&&fromDate=' + fdate + '&&toDate=' + tdate);
    }

    getOrderSummary(id) {
        return this.http.get(window['url'] + '/newyess/orders/summary?onlyPendingActions=true&&serviceContractorId=' + id + '&&status=12');
    }

    OrderReject(id) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/reject', null);
    }

    RequestReject(id) {
        return this.http.put(window['url'] + '/newyess/requests/' + id + '/reject', null);
    }

    getBillByUnit(id, id1, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/billByUnit/' + id1, data);
    }

    applyDiscountOrderRemove(id, id1) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/removeDiscount?couponCode=' + id1, null);
    }

    getAllOrderByStatus(id1, id2, nbr) {
        return this.http.get(window['url'] + '/newyess/orders' + '?orderType=1&&serviceContractorId=' + id1 + '&&status=' + id2 + '&&pageNbr=' + nbr + '&&pageSize=50');
    }

    getAllSinRequestContractor(id, date, id1) {
        return this.http.get(window['url'] + '/newyess/requests' + '?serviceContractorId=' + id + '&&subscriptionInd=false&&apptDate=' + date + '&&pageNbr=' + id1 + '&&pageSize=50');
    }

    getAllSinRequestContractorMatTable(id, date) {
        return this.http.get(window['url'] + '/newyess/requests' + '?serviceContractorId=' + id + '&&subscriptionInd=false&&apptDate=' + date);
    }

    searchOrderByCust(cName) {
        return this.http.get(window['url'] + '/newyess/orders' + '?custName=' + cName);
    }

    postOrderVendorPaymentDetails(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/vendorRecordPay', data);
    }

    applyCredits(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/applyCredits', data);
    }

    removeCredits(id) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/removeCredits', null);
    }

    postCreadits(id, id1) {
        return this.http.post(window['url'] + '/newyess/users/' + id + '/userCredits?creditPoints=' + id1, null);
    }

    applyCreditsForVendor(id, data) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/applyCreditsForVendor', data);
    }

    removeCreditsForVendor(id) {
        return this.http.put(window['url'] + '/newyess/orders/' + id + '/removeCreditsForVendor', null);
    }

    getOrdersSearch(id, data) {
        return this.http.post(window['url'] + '/newyess/orders/search/basicDetails?pageNbr=' + id + '&&pageSize=50', data);
    }

    getOrdersSummary(data) {
        return this.http.post(window['url'] + '/newyess/orders/search/basicDetails?count=true', data);
    }

    getAllRequestByCategory(date, id1) {
        return this.http.get(window['url'] + '/newyess/requests' + '?apptDate=' + date + '&&pageNbr=' + id1 + '&&pageSize=50');
    }

    getAllRequestForMatTable(date) {
        return this.http.get(window['url'] + '/newyess/requests' + '?apptDate=' + date);
    }

    filterContractor(userData) {
        return this.http.post(window['url'] + '/newyess/users/search?contractorFilter=true', userData);
    }
    getAllmembership() {
        return this.http.get(window['url'] + '/newyess/membership');
    }
    buyMembership(data) {
        return this.http.post(window['url'] + '/newyess/membership/buyMembershipScheme', data);
    }
    myMembership(data) {
        return this.http.post(window['url'] + '/newyess/membership/myMembershipPackage', data);
    }
    getnewUser(data) {
        return this.http.post(window['url'] + '/newyess/customer?phnNbr=' + data ,null);
    }
}
